export const menus = [
	{ is_header: true, title: "Navegación" },
	{ path: "/dashboard", icon: "bi bi-house", title: "Inicio" },
	{ path: "/rooms", icon: "bi bi-door-closed", title: "Habitaciones" },
	{ path: "/customers", icon: "bi bi-people", title: "Clientes" },
	{ path: "/reservations", icon: "bi bi-calendar-check", title: "Reservas" },
	{ path: "/payments", icon: "bi bi-credit-card", title: "Pagos" },
	{ path: "/users", icon: "bi bi-people", title: "Usuarios" },
	{ path: "/settings", icon: "bi bi-gear", title: "Configuración" },
];

export const ibMenu = [
	{ is_header: true, title: "Panel IB" },
	{ path: "/ibDashboard", icon: "bi bi-cpu", title: "Inicio" },
	{ path: "/ibUsers", icon: "bi bi-person-plus", title: "Referidos" },
	{ path: "/ibPurchases", icon: "bi bi-cash-stack", title: "Compras" },
];

export const AppIBDashboard = [
	{ is_header: true, title: "Panel Administrativo" },
	{ path: "/appIbDashboard", icon: "bi bi-cpu", title: "Inicio" },
	{ path: "/appIbUsers", icon: "bi bi-person-plus", title: "Clientes" },
	{ path: "/appIbPurchases", icon: "bi bi-cash-stack", title: "Compras" },
	{ path: "/appIbSignals", icon: "bi bi-person-plus", title: "Señales" },
	{ path: "/appIbEvents", icon: "bi bi-person-plus", title: "Eventos" },
];

export const affiliateMenu = [{ path: "/panel", icon: "bi bi-cpu", title: "Inicio" }];
